// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f198fd35","641":"e3eaabfb"}[chunkId] + ".chunk.js";
};